var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "errorList", attrs: { id: "errors" } }, [
    _vm.errorList.length
      ? _c(
          "div",
          { staticClass: "alert alert-danger" },
          [
            _vm.errorList.length > 1
              ? [
                  _c(
                    "ul",
                    _vm._l(_vm.errorList, function (error) {
                      return _c("li", [_vm._v(_vm._s(error))])
                    }),
                    0
                  ),
                ]
              : [
                  _vm._v(
                    "\n            " + _vm._s(_vm.errorList[0]) + "\n        "
                  ),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "fatal-error-modal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "fatalErrorLabel",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "fatalErrorLabel" },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.trans("booking-process.error.fatal_error_label")
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("p", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.trans(
                          "booking-process.error.fatal_error_description"
                        )
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }